import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom';
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils.js';
import Button from '@material-ui/core/Button';
import withMenuPermission from "../../widgets/withMenuPermission.js";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AlertItem from "../../widgets/AlertItem.jsx";
import './Style.css'
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EnhancedToolbar from '../../widgets/Toolbar.jsx';
import ClearIcon from '@material-ui/icons/Clear';
import { Box, Radio, RadioGroup, FormControl, FormControlLabel, Tooltip, IconButton } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
const utils = new ViewUtils();
const toolbarRef = React.createRef();


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#01579B',
        color: theme.palette.common.white,
        border: '1px solid white',
    },
    body: {
        fontSize: 11,
    },
}))(TableCell);

const StyledTableTextCell = withStyles((theme) => ({
    body: {
        fontSize: 14,
        fontWeight: 500
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            height: theme.palette.action.main
        },
    },
}))(TableRow);

const useStyles = theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        flex: 1,
        color: 'white',
    },
    table: {
        minWidth: 700,
    },
});

class Feedback extends Component {
    constructor(props) {
        super(props)
        this.state = {
            objectProps: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.object)) ? this.props.location.state.object : null,
            formObject: null,
            lookupFYArray: null,
            FinancialYearID: null,
            model: {
                Name: "",
            },
            title: "",
            OrganisationID: (!utils.isNull(this.props.location.state) && !utils.isNull(this.props.location.state.organisationID)) ? this.props.location.state.organisationID : null,
            Message: "",
            MessageStyle: "",
            showInfoMessage : true
        };

        this.toolbarConfig = {
            items: [

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },

                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', disabled: utils.isNull(this.state.formObject), icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit },
                    ]
                }
            ]
        }
    }

    componentDidMount() {
        this.getlookup(this.state.id)
    }

    getForms(financialYearID) {
        let url = "api/sims/StakeholderFeedback/GetStakeholderFeedback?OrganisationId=" + this.state.OrganisationID + "&FinancialYearId=" + financialYearID;
        utils.invokeUrl(url, (response) => {
            this.setState({
                formObject: response,
                FinancialYearID : financialYearID
            })
            toolbarRef.current.setButtonDisabled("save", response === null || response.length === 0);
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }
    getlookup(id) {
        let url = "api/sims/StakeholderFeedback/GetFinancialYearsNotAll";
        utils.invokeUrl(url, (response) => {
            this.setState({ lookupFYArray: response })
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
        
    }
    handleChecklistArrayFeedback = (event, index) => {
    const { value } = event.target; // "1" or "0" from RadioGroup
    const values = [...this.state.formObject.OrgStakeholderFeedbackChecklistDtoList];
    const indexObject = { ...values[index] };
    
    // Map "1" to true and "0" to false
    // If the value is empty or something else, set to null
    indexObject.Feedback = value === "1" ? true : value === "0" ? false : null;
    
    values[index] = indexObject;
    const finalObject = { 
        ...this.state.formObject, 
        OrgStakeholderFeedbackChecklistDtoList: values 
    };
    this.setState({ formObject: finalObject });
    }

    handleChecklistArrayC = (event, index) => {
        const values = [...this.state.formObject.OrgStakeholderFeedbackChecklistDtoList];
        const indexObject = { ...values[index] };
        indexObject.Comments = event.target.value;
        values[index] = indexObject;
        const finalObject = { ...this.state.formObject, OrgStakeholderFeedbackChecklistDtoList: values }
        this.setState({ formObject: finalObject });
    }

    SaveChecklist = () => {
        let url = "api/sims/StakeholderFeedback/UpdateStakeholderChecklist";
        utils.invokeUrl(url, (response) => {
            this.successCallback(response);
        },
            (response) => {
                this.error(response);
            },
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(this.state.formObject)
            }
        )
    }

    successCallback(response) {

        if (response.MessageType === "WARNING") {
            let errResult = JSON.parse(response.Message);
            let message = "";
            errResult.map((item, index) => (
                message += item.Item1 + ' : ' + item.Item2 + '\n'
            ))
        this.setState({ Message: message, MessageStyle: response.MessageType });
        }
        else {
        this.setState({ Message: response.Message, MessageStyle: response.MessageType });
        this.componentDidMount();
        this.getForms(this.state.FinancialYearID);
        }
    }
    error(response) {
        this.setState({ Message: response.Message, MessageStyle: response.MessageType });
    }

    handleToolbarButtonClick(buttonId) {
        if (buttonId === "close") {
            this.props.history.push({
                pathname: "/skillsOrganisation",
                state: { selection: this.props.location.state.organisationID }
            })
        }
        else if (buttonId === "save") {
            this.SaveChecklist();
        }
    }

    handleFinancialYear = (event) => {
        if(event.target.value && event.target.value > 0)
        {
            this.setState({ Message: "", MessageStyle: "" });
            this.getForms(event.target.value);
        }

    }

    buttonSubmitClickHandler() {
        this.submit();
    }

    render() {

        const { classes } = this.props;
        const tablerows = !utils.isNull(this.state.formObject) ? this.state.formObject.OrgStakeholderFeedbackChecklistDtoList.map((item, index) => (
                <StyledTableRow key={item.Number}>
                    <StyledTableCell component="th" scope="row">
                        {item.Number}
                    </StyledTableCell>
                    <StyledTableCell align="left">{item.CheckList}</StyledTableCell>
                    <StyledTableCell align="left" component="th" scope="row" >
                        <FormControl 
                            variant="outlined" 
                            size="small" 
                            margin="normal" 
                            style={{ minWidth: "200px", width: "100%" }}
                        >
                            <Box 
                                style={{ 
                                    padding: '2px 8px 2px 14px', // Reduced right padding to fit the icon better
                                    display: 'flex',
                                    flexDirection: 'row', // Ensures horizontal alignment
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    minHeight: '40px'
                                }}
                            >
                                <RadioGroup
                                    row
                                    name={"Feedback" + item.Number}
                                    value={item.Feedback === true ? "1" : item.Feedback === false ? "0" : ""}
                                    onChange={(e) => this.handleChecklistArrayFeedback(e, index)}
                                >
                                    <FormControlLabel 
                                        value="1" 
                                        control={<Radio size="small" color="primary" />} 
                                        label="Yes" 
                                    />
                                    <FormControlLabel 
                                        value="0" 
                                        control={<Radio size="small" color="secondary" />} 
                                        label="No" 
                                    />
                                </RadioGroup>

                                {/* This stays to the right of the RadioButtons */}
                                {item.Feedback !== null && (
                                    <Tooltip title="Reset Selection" arrow placement="top">
                                        <IconButton 
                                            size="small" 
                                            onClick={() => this.handleChecklistArrayFeedback({ target: { value: null } }, index)}
                                            style={{ marginLeft: '8px' }}
                                        >
                                            <ClearIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Box>
                        </FormControl>
                    </StyledTableCell>
                    <StyledTableCell align="left" component="th" scope="row" >
                        <TextField id={"Comments" + item.Number} multiline rows={2} value={item.Comments} variant="outlined" style={{ minWidth: "600px", width: "100% !important" }} onChange={(values) => this.handleChecklistArrayC(values, index)}> </TextField>
                    </StyledTableCell>
                </StyledTableRow >
                
        ))
            :
            null;



        return (
            <ViewContainer topPadding="0" title="">
               <p className="legend">
                    {"Organisation > Stakeholder Feedback " + (this.props.location.state.organisationName !== null ? "> " + this.props.location.state.organisationName + (this.props.location.state.sdlnumber !== null ? " - " + this.props.location.state.sdlnumber : "") : "> Add")}
                </p>
                <br/>
                
                {this.state.showInfoMessage && (
                    <Alert 
                        severity="info" 
                        onClose={() => this.setState({ showInfoMessage: false })}
                        style={{ marginBottom: '20px' }}
                    >
                        <strong>Thank you for completing your WSP/ATR.</strong> Please kindly take a few minutes to complete this questionnaire. All information collected is and will be used to improve how we support you and any system changes that will make this process less challenging, seamless and friendly to use.
                    </Alert>
                )}
                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />
                <div className="searchResults">

                    <EnhancedToolbar highlight={false}
                        title="Stakeholder Feedback"
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={this.toolbarConfig}
                    />
                </div>
                <table className={classes.table} aria-label="simple table" size="small">
                    <tbody>
                        <TableRow>
                                <td align="left">
                                    <TextField className="w-30" id="FinancialYearID" label="Financial Year" value={!utils.isNull(this.state.formObject) ? this.state.formObject.FinancialYearID : 0} select margin="normal" size="small" variant="outlined" style={{ minWidth: "300px", width: "100% !important" }} onChange={(values) => this.handleFinancialYear(values)}>
                                        <MenuItem value={0} key={0} >  </MenuItem>
                                        {!utils.isNull(this.state.lookupFYArray) ? this.state.lookupFYArray.map((lookupFYitem, index) => (

                                            <MenuItem value={lookupFYitem.Id} key={lookupFYitem.Id} >{lookupFYitem.Description}</MenuItem>

                                        )) : null}
                                    </TextField>
                                </td>
                            </TableRow>
                    </tbody>
                </table>
                <br />
                <br />
                <Table className={classes.table} size="small" >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">#</StyledTableCell>
                            <StyledTableCell>Feedback On</StyledTableCell>
                            <StyledTableCell>(Y/N)</StyledTableCell>
                            <StyledTableCell>Comments</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tablerows}
                    </TableBody>
                </Table>
            </ViewContainer>

        );
    }
}

export default withRouter(withStyles(useStyles())(withMenuPermission(Feedback)));